<!-- Main container following application layout patterns -->
<div class="main-content">  <!-- Header section consistent with other pages -->
  <div class="header-section">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-left">
        <h1 class="main-title">{{ 'REISSUE.TITLE' | translate }}</h1>
        <p class="main-subtitle">{{ 'REISSUE.SUBTITLE' | translate }}</p>
      </div>
      
      <!-- Header controls -->
      <div class="header-controls">
        <!-- View mode toggle -->
        <div class="btn-group" role="group">
          <button 
            type="button" 
            class="btn" 
            [ngClass]="viewMode === 'search' ? 'btn-primary' : 'btn-outline-primary'"
            (click)="switchViewMode('search')">
            <i class="fas fa-search me-2"></i>
            {{ 'REISSUE.VIEW_MODES.SEARCH' | translate }}
          </button>
          <button 
            type="button" 
            class="btn" 
            [ngClass]="viewMode === 'reissue' ? 'btn-primary' : 'btn-outline-primary'"
            (click)="switchViewMode('reissue')">
            <i class="fas fa-redo me-2"></i>
            {{ 'REISSUE.VIEW_MODES.REISSUE' | translate }}
            <span class="badge bg-light text-dark ms-2" *ngIf="reissuedWaybills.length > 0">
              {{ reissuedWaybills.length }}
            </span>
          </button>
        </div>
      </div>
    </div>
    
    <!-- Success/Error Messages -->
    <div class="mt-3" *ngIf="successMessage || errorMessage">
      <div class="alert alert-success alert-dismissible fade show" *ngIf="successMessage" role="alert">
        <i class="fas fa-check-circle me-2"></i>
        {{ successMessage }}
        <button type="button" class="btn-close" (click)="successMessage = ''" aria-label="Close"></button>
      </div>
      
      <div class="alert alert-danger alert-dismissible fade show" *ngIf="errorMessage" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ errorMessage }}
        <button type="button" class="btn-close" (click)="errorMessage = ''" aria-label="Close"></button>
      </div>
    </div>
    
    <!-- Loading indicator -->
    <div class="text-center mt-3" *ngIf="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- SEARCH VIEW - Ricerca e selezione bolle da ri-emettere -->
  <div *ngIf="viewMode === 'search'">
      <!-- Quick search bar -->
    <div class="search-container mb-4">
      <div class="row g-3">
        <div class="col-md-8">
          <div class="input-group search-input-container">
            <span class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
              [placeholder]="'REISSUE.SEARCH.PLACEHOLDER' | translate">
            <button 
              class="btn btn-outline-secondary" 
              *ngIf="searchTerm" 
              (click)="searchTerm = ''; onSearchChange()"
              type="button">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <button 
            type="button" 
            class="btn btn-outline-primary w-100" 
            (click)="toggleFormCollapse()"
            [attr.aria-expanded]="!isFormCollapsed"
            aria-controls="reissueForm">
            <i class="fas" [ngClass]="isFormCollapsed ? 'fa-filter' : 'fa-filter-circle-xmark'"></i>
            {{ 'REISSUE.ADVANCED_FILTERS' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Advanced search form (collapsible) -->
    <div class="collapse" [ngClass]="{'show': !isFormCollapsed}" id="reissueForm">
      <form [formGroup]="reissueForm" class="reissue-form">        <div class="card">
          <div class="card-header">
            <div class="header-title">
              <i class="fas fa-filter header-icon"></i>
              <h3>{{ 'REISSUE.SEARCH_CRITERIA.TITLE' | translate }}</h3>
            </div>
          </div>
          <div class="card-body">
            <div formGroupName="searchCriteria">
              <div class="row g-3">
                <div class="col-md-4">
                  <label for="waybillCode" class="form-label">
                    {{ 'REISSUE.SEARCH_CRITERIA.WAYBILL_CODE' | translate }}
                  </label>
                  <input 
                    type="text" 
                    id="waybillCode"
                    class="form-control" 
                    formControlName="waybillCode"
                    (input)="onFilterChange()">
                </div>
                
                <div class="col-md-4">
                  <label for="dealerCode" class="form-label">
                    {{ 'REISSUE.SEARCH_CRITERIA.DEALER' | translate }}
                  </label>
                  <select 
                    id="dealerCode"
                    class="form-select" 
                    formControlName="dealerCode"
                    (change)="onFilterChange()">
                    <option value="">{{ 'REISSUE.SEARCH_CRITERIA.ALL_DEALERS' | translate }}</option>
                    <option *ngFor="let dealer of dealers" [value]="dealer.dealerCode">
                      {{ dealer.dealerName }} ({{ dealer.dealerCode }})
                    </option>
                  </select>
                </div>
                
                <div class="col-md-4">
                  <label for="brandCode" class="form-label">
                    {{ 'REISSUE.SEARCH_CRITERIA.BRAND' | translate }}
                  </label>
                  <select 
                    id="brandCode"
                    class="form-select" 
                    formControlName="brandCode"
                    (change)="onFilterChange()">
                    <option value="">{{ 'REISSUE.SEARCH_CRITERIA.ALL_BRANDS' | translate }}</option>
                    <option *ngFor="let brand of brands" [value]="brand.brandCode">
                      {{ brand.brandName }} ({{ brand.brandCode }})
                    </option>
                  </select>
                </div>
                
                <div class="col-md-4">
                  <label for="dateFrom" class="form-label">
                    {{ 'REISSUE.SEARCH_CRITERIA.DATE_FROM' | translate }}
                  </label>
                  <input 
                    type="date" 
                    id="dateFrom"
                    class="form-control" 
                    formControlName="dateFrom"
                    (change)="onFilterChange()">
                </div>
                
                <div class="col-md-4">
                  <label for="dateTo" class="form-label">
                    {{ 'REISSUE.SEARCH_CRITERIA.DATE_TO' | translate }}
                  </label>
                  <input 
                    type="date" 
                    id="dateTo"
                    class="form-control" 
                    formControlName="dateTo"
                    (change)="onFilterChange()">
                </div>
                
                <div class="col-md-4">
                  <label for="status" class="form-label">
                    {{ 'REISSUE.SEARCH_CRITERIA.STATUS' | translate }}
                  </label>
                  <select 
                    id="status"
                    class="form-select" 
                    formControlName="status"
                    (change)="onFilterChange()">
                    <option value="">{{ 'REISSUE.SEARCH_CRITERIA.ALL_STATUSES' | translate }}</option>
                    <option *ngFor="let status of WAYBILL_STATUSES" [value]="status">
                      {{ 'WAYBILL.STATUS.' + status | translate }}
                    </option>
                  </select>
                </div>
              </div>
              
              <div class="row mt-3">
                <div class="col-12">
                  <button 
                    type="button" 
                    class="btn btn-secondary me-2"
                    (click)="reissueForm.get('searchCriteria')?.reset(); onFilterChange()">
                    <i class="fas fa-times me-2"></i>
                    {{ 'REISSUE.SEARCH_CRITERIA.CLEAR_FILTERS' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Selection and reissue form -->
    <div class="card mt-4" *ngIf="selectedWaybillsForReissue.length > 0">
      <div class="card-header">
        <div class="header-title">
          <i class="fas fa-redo me-2"></i>
          {{ 'REISSUE.REISSUE_DATA.TITLE' | translate }}
          <span class="badge bg-primary ms-2">{{ selectedWaybillsForReissue.length }}</span>
        </div>
      </div>
      <div class="card-body">
        <form [formGroup]="reissueForm" (ngSubmit)="onSubmit()">
          <div formGroupName="reissueData">
            <div class="row g-3">
              <div class="col-md-4">
                <label for="newDeliveryDate" class="form-label required">
                  {{ 'REISSUE.REISSUE_DATA.NEW_DELIVERY_DATE' | translate }}
                </label>
                <input 
                  type="date" 
                  id="newDeliveryDate"
                  #reissueDateInput
                  class="form-control" 
                  formControlName="newDeliveryDate"
                  [class.is-invalid]="isFieldInvalid('reissueData.newDeliveryDate')">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('reissueData.newDeliveryDate')">
                  {{ getFieldError('reissueData.newDeliveryDate') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="newDeliveryMethod" class="form-label required">
                  {{ 'REISSUE.REISSUE_DATA.NEW_DELIVERY_METHOD' | translate }}
                </label>
                <select 
                  id="newDeliveryMethod"
                  class="form-select" 
                  formControlName="newDeliveryMethod"
                  [class.is-invalid]="isFieldInvalid('reissueData.newDeliveryMethod')">
                  <option value="">{{ 'REISSUE.REISSUE_DATA.SELECT_METHOD' | translate }}</option>
                  <option *ngFor="let method of DELIVERY_METHODS" [value]="method">
                    {{ 'WAYBILL.DELIVERY_METHOD.' + method | translate }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('reissueData.newDeliveryMethod')">
                  {{ getFieldError('reissueData.newDeliveryMethod') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="newDeliveryType" class="form-label required">
                  {{ 'REISSUE.REISSUE_DATA.NEW_DELIVERY_TYPE' | translate }}
                </label>
                <select 
                  id="newDeliveryType"
                  class="form-select" 
                  formControlName="newDeliveryType"
                  [class.is-invalid]="isFieldInvalid('reissueData.newDeliveryType')">
                  <option value="">{{ 'REISSUE.REISSUE_DATA.SELECT_TYPE' | translate }}</option>
                  <option *ngFor="let type of DELIVERY_TYPES" [value]="type">
                    {{ 'WAYBILL.DELIVERY_TYPE.' + type | translate }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('reissueData.newDeliveryType')">
                  {{ getFieldError('reissueData.newDeliveryType') }}
                </div>
              </div>
              
              <div class="col-md-8">
                <label for="reason" class="form-label required">
                  {{ 'REISSUE.REISSUE_DATA.REASON' | translate }}
                </label>
                <textarea 
                  id="reason"
                  class="form-control" 
                  formControlName="reason"
                  rows="3"
                  [class.is-invalid]="isFieldInvalid('reissueData.reason')"
                  [placeholder]="'REISSUE.REISSUE_DATA.REASON_PLACEHOLDER' | translate"></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('reissueData.reason')">
                  {{ getFieldError('reissueData.reason') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="notes" class="form-label">
                  {{ 'REISSUE.REISSUE_DATA.NOTES' | translate }}
                </label>
                <textarea 
                  id="notes"
                  class="form-control" 
                  formControlName="notes"
                  rows="3"
                  [placeholder]="'REISSUE.REISSUE_DATA.NOTES_PLACEHOLDER' | translate"></textarea>
              </div>
            </div>
            
            <div class="row mt-4">
              <div class="col-12">
                <button 
                  type="submit" 
                  class="btn btn-primary btn-lg me-3"
                  [disabled]="isSubmitting">
                  <i class="fas fa-redo me-2"></i>
                  <span *ngIf="!isSubmitting">{{ 'REISSUE.ACTIONS.REISSUE_WAYBILLS' | translate }}</span>
                  <span *ngIf="isSubmitting">
                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ 'REISSUE.ACTIONS.PROCESSING' | translate }}
                  </span>
                </button>
                <button 
                  type="button" 
                  class="btn btn-outline-secondary"
                  (click)="selectedWaybillsForReissue = []; selectAllChecked = false">
                  <i class="fas fa-times me-2"></i>
                  {{ 'REISSUE.ACTIONS.CANCEL_SELECTION' | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Waybills table -->
    <div class="card table-container">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-file-invoice me-2"></i>
            {{ 'REISSUE.ORIGINAL_WAYBILLS.TITLE' | translate }}
            <span class="badge bg-secondary ms-2">{{ totalItems }}</span>
          </div>
          <div class="header-actions">
            <span class="text-muted me-3" *ngIf="selectedWaybillsForReissue.length > 0">
              {{ 'REISSUE.ORIGINAL_WAYBILLS.SELECTED' | translate }}: {{ selectedWaybillsForReissue.length }}
            </span>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light sticky-header">
            <tr>
              <th scope="col" class="text-center" style="width: 50px;">
                <div class="form-check">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [checked]="selectAllChecked"
                    (change)="toggleSelectAll()"
                    id="selectAll">
                  <label class="form-check-label visually-hidden" for="selectAll">
                    {{ 'REISSUE.ORIGINAL_WAYBILLS.SELECT_ALL' | translate }}
                  </label>
                </div>
              </th>
              <th scope="col">{{ 'REISSUE.ORIGINAL_WAYBILLS.WAYBILL_CODE' | translate }}</th>
              <th scope="col">{{ 'REISSUE.ORIGINAL_WAYBILLS.DATE' | translate }}</th>
              <th scope="col">{{ 'REISSUE.ORIGINAL_WAYBILLS.DEALER' | translate }}</th>
              <th scope="col">{{ 'REISSUE.ORIGINAL_WAYBILLS.BRAND' | translate }}</th>
              <th scope="col">{{ 'REISSUE.ORIGINAL_WAYBILLS.STATUS' | translate }}</th>
              <th scope="col">{{ 'REISSUE.ORIGINAL_WAYBILLS.DELIVERY_DATE' | translate }}</th>
              <th scope="col" class="text-end">{{ 'REISSUE.ORIGINAL_WAYBILLS.PARCELS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let waybill of getFilteredWaybills(); trackBy: trackByWaybillCode">
              <td class="text-center">
                <div class="form-check">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [checked]="isWaybillSelected(waybill.waybillCode)"
                    (change)="toggleWaybillSelection(waybill.waybillCode)"
                    [id]="'waybill-' + waybill.waybillCode">
                  <label class="form-check-label visually-hidden" [for]="'waybill-' + waybill.waybillCode">
                    {{ 'REISSUE.ORIGINAL_WAYBILLS.SELECT_WAYBILL' | translate }}
                  </label>
                </div>
              </td>              <td>
                <strong>{{ waybill.waybillCode }}</strong>
                <div class="text-muted small" *ngIf="waybill.waybillNote">
                  <i class="fas fa-sticky-note me-1"></i>
                  {{ waybill.waybillNote | slice:0:50 }}{{ waybill.waybillNote.length > 50 ? '...' : '' }}
                </div>
              </td>
              <td>{{ formatDate(waybill.waybillDate) }}</td>              <td>
                <div>{{ waybill.waybillDealerCode }}</div>
              </td>
              <td>
                <div>{{ waybill.waybillBrandCode }}</div>
              </td>
              <td>
                <span [ngClass]="getStatusClass(getWaybillStatus(waybill))">
                  {{ 'WAYBILL.STATUS.' + getWaybillStatus(waybill) | translate }}
                </span>
              </td>
              <td>
                <div *ngIf="waybill.waybillEstimatedDeliveryDate">
                  {{ formatDate(waybill.waybillEstimatedDeliveryDate) }}
                </div>                <div class="text-muted" *ngIf="!waybill.waybillEstimatedDeliveryDate">
                  {{ 'REISSUE.ORIGINAL_WAYBILLS.NO_DATE' | translate }}
                </div>
              </td>
              <td class="text-end">
                <span class="badge bg-info">
                  0
                </span>
              </td>
            </tr>
            
            <!-- Empty state -->
            <tr *ngIf="getFilteredWaybills().length === 0">
              <td colspan="8" class="text-center py-5">
                <div class="empty-state">
                  <i class="fas fa-search fa-3x text-muted mb-3"></i>
                  <h5 class="text-muted">{{ 'REISSUE.ORIGINAL_WAYBILLS.NO_RESULTS' | translate }}</h5>
                  <p class="text-muted">{{ 'REISSUE.ORIGINAL_WAYBILLS.NO_RESULTS_DESC' | translate }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->      <div class="card-footer" *ngIf="totalItems > itemsPerPage">
        <div class="pagination-controls">
          <pagination-controls 
            id="reissue-pagination" 
            [maxSize]="5" 
            [autoHide]="true" 
            [responsive]="true" 
            previousLabel="←"
            nextLabel="→"
            (pageChange)="onPageChange($event)">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>

  <!-- REISSUE VIEW - Risultati ri-emissione -->
  <div *ngIf="viewMode === 'reissue'">
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-check-circle me-2 text-success"></i>
            {{ 'REISSUE.REISSUED_WAYBILLS.TITLE' | translate }}
            <span class="badge bg-success ms-2">{{ reissuedWaybills.length }}</span>
          </div>
          <div class="header-actions">
            <button 
              type="button" 
              class="btn btn-primary me-2"
              (click)="generateLabelsForReissuedWaybills()"
              [disabled]="reissuedWaybills.length === 0">
              <i class="fas fa-print me-2"></i>
              {{ 'REISSUE.ACTIONS.GENERATE_LABELS' | translate }}
            </button>
            <button 
              type="button" 
              class="btn btn-outline-success"
              (click)="exportReissuedWaybills()"
              [disabled]="reissuedWaybills.length === 0">
              <i class="fas fa-download me-2"></i>
              {{ 'REISSUE.ACTIONS.EXPORT_EXCEL' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th scope="col">{{ 'REISSUE.REISSUED_WAYBILLS.NEW_CODE' | translate }}</th>
              <th scope="col">{{ 'REISSUE.REISSUED_WAYBILLS.ORIGINAL_CODE' | translate }}</th>
              <th scope="col">{{ 'REISSUE.REISSUED_WAYBILLS.REISSUE_DATE' | translate }}</th>
              <th scope="col">{{ 'REISSUE.REISSUED_WAYBILLS.NEW_DELIVERY_DATE' | translate }}</th>
              <th scope="col">{{ 'REISSUE.REISSUED_WAYBILLS.DELIVERY_METHOD' | translate }}</th>
              <th scope="col">{{ 'REISSUE.REISSUED_WAYBILLS.STATUS' | translate }}</th>
              <th scope="col" class="text-end">{{ 'REISSUE.REISSUED_WAYBILLS.PARCELS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let waybill of reissuedWaybills; trackBy: trackByReissueWaybillCode">              <td>
                <strong class="text-primary">{{ waybill.waybillCode }}</strong>
                <div class="text-muted small" *ngIf="waybill.waybillNote">
                  <i class="fas fa-sticky-note me-1"></i>
                  {{ waybill.waybillNote | slice:0:50 }}{{ waybill.waybillNote.length > 50 ? '...' : '' }}
                </div>
              </td>
              <td>
                <code>{{ waybill.waybillOriginCode }}</code>
              </td>
              <td>{{ formatDate(waybill.waybillDate) }}</td>
              <td>{{ formatDate(waybill.waybillEstimatedDeliveryDate) }}</td>
              <td>
                <div>{{ 'WAYBILL.DELIVERY_METHOD.' + waybill.waybillDeliveryMethod | translate }}</div>              <div class="text-muted small">{{ 'WAYBILL.DELIVERY_TYPE.' + waybill.waybillDeliveryType | translate }}</div>
              </td>
              <td>
                <span [ngClass]="getStatusClass(getWaybillStatus(waybill))">
                  {{ 'WAYBILL.STATUS.' + getWaybillStatus(waybill) | translate }}              </span>
              </td>
              <td class="text-end">
                <span class="badge bg-info">
                  {{ waybill.parcels?.length || 0 }}
                </span>
              </td>
            </tr>
            
            <!-- Empty state -->
            <tr *ngIf="reissuedWaybills.length === 0">
              <td colspan="7" class="text-center py-5">
                <div class="empty-state">
                  <i class="fas fa-redo fa-3x text-muted mb-3"></i>
                  <h5 class="text-muted">{{ 'REISSUE.REISSUED_WAYBILLS.NO_REISSUED' | translate }}</h5>
                  <p class="text-muted">{{ 'REISSUE.REISSUED_WAYBILLS.NO_REISSUED_DESC' | translate }}</p>
                  <button 
                    type="button" 
                    class="btn btn-primary"
                    (click)="switchViewMode('search')">
                    <i class="fas fa-search me-2"></i>
                    {{ 'REISSUE.ACTIONS.START_REISSUE' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
